module.exports = __webpack_public_path__ + "static/media/temp-wody-ok.0335aeef.svg";